module.exports = __webpack_public_path__ + "img/t.27cb4853.svg";